import Api from "js/core/api";

export default function apiMiddleware() {
    return ({ dispatch, getState }) => {
        return next => action => {
            if (typeof action === "function") {
                return action(dispatch, getState);
            }

            const { promise, types, ...rest } = action;
            if (!promise) {
                return next(action);
            }

            const [REQUEST, SUCCESS, FAILURE] = types;
            next({ ...rest, type: REQUEST });

            const actionPromise = promise(Api);
            actionPromise
                .then(
                    result => {
                        next({ ...rest, result, type: SUCCESS });
                    },
                    error => {
                        if (error.status === 401) {
                            console.log("401", error);
                        } else if (error.status === 403) {
                            console.log("403", error);
                        } else {
                            console.log(error);
                        }
                        next({ ...rest, error, type: FAILURE });
                    }
                )
                .catch(error => {
                    console.error("MIDDLEWARE ERROR:", error);
                    next({ ...rest, error, type: FAILURE });
                });

            return actionPromise;
        };
    };
}
